import React from 'react'
import "./Footer.css";


const Footer = () => {
  return (
    <footer className="footer">
        Copyright &#169; 2025 Gautam Bollu.All right recieived.
    </footer>
)
}

export default Footer